import { WebPubSubClient } from '@azure/web-pubsub-client'

import constants from '@/constants'
import { useWebPubSubStore } from '@/modules/global/webPubSubStore'

const groupListeners = {}

async function getClient() {
  if (window.webPubSubClientPromise) {
    return window.webPubSubClientPromise
  }
  if (window.webPubSubClient) {
    return window.webPubSubClient
  }

  // Create a promise for fetching the client, so that we can return the existing promise if
  // two pieces of code want to get the client directly after each other
  window.webPubSubClientPromise = new Promise((resolve, reject) => {
    const webPubSubStore = useWebPubSubStore()

    webPubSubStore
      .getWebPubSubToken()
      .then((token) => {
        const accessUrl = `wss://${process.env.VUE_APP_WEB_PUB_SUB_ENDPOINT}/client/hubs/${constants.WEB_PUB_SUB.HUB_FRONTEND_PREFIX}_${webPubSubStore.webPubSubTokenAppId}?access_token=${token}`

        const client = new WebPubSubClient(accessUrl)
        window.webPubSubClient = client

        client.on('connected', () => {
          // This function accpet event as a paramter
        })
        client.on('disconnected', () => {
          // This function accpet event as a paramter
        })
        client.on('stopped', () => {
          // This function accpet event as a paramter
        })
        client.on('server-message', () => {
          // This function accpet event as a paramter
        })
        client.on('group-message', () => {
          // This function accpet event as a paramter
        })
        client.on('rejoin-group-failed', () => {
          // This function accpet event as a paramter
        })

        return client.start()
      })
      .then(() => {
        resolve(window.webPubSubClient)
        window.webPubSubClientPromise = null
      })
      .catch((error) => {
        window.webPubSubClient = null
        window.webPubSubClientPromise = null
        reject(error)
      })
  })

  return window.webPubSubClientPromise
}

export async function joinGroup(groupName, callback) {
  const client = await getClient()

  // Only run the callback if the group name matches
  const guardedCallback = (e) => {
    if (e.message.group !== groupName) {
      return
    }
    callback(e.message.data)
  }
  client.on('group-message', guardedCallback)
  await client.joinGroup(groupName)

  if (!groupListeners[groupName]) {
    groupListeners[groupName] = 0
  }
  groupListeners[groupName]++

  function disconnect() {
    groupListeners[groupName]--
    if (groupListeners[groupName] <= 0) {
      client.leaveGroup(groupName)
    }
    client.off('group-message', guardedCallback)
  }

  // onUnmounted(disconnect)

  return disconnect
}
